import { and, isControl, optionIs, rankWith } from "@jsonforms/core";
export default rankWith(50,and(isControl,optionIs("EventSupportManagement",true)));
